export default "./dist/stdassets/images/icons/legend-raster.png";